import React, { useEffect, useState } from "react";
import "./Gift.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import { Button, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBook, faFileLines } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { getGiftHistory, receiveGiftCode } from "../../features/auth/Slice";
import CustomPagination from "../Common/Common_Component/CustomPagination/CustomPagination";
import { useForm } from "react-hook-form";
import { formatAmount, formatNotifDate } from "../../utils/common";
import Successfull_strip_modal from "../Common/Common_Component/Common_Modal/Successfull_strip_modal/Successfull_strip_modal";

function Gift() {
  const [loading, setLoading] = useState();
  const [modalShow, setModalShow] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch();
  const giftHistory = useSelector((state) => state.auth.GiftHistory);


  const fetch = async (page = 1) => {
    await dispatch(getGiftHistory({ page, }))
  }

  useEffect(() => { fetch(1) }, [dispatch]);

  const handlePageChange = async (page) => {
    fetch(page)
  };

  const onSubmit = async (data) => {
    setLoading(true)
    const res = await dispatch(receiveGiftCode({ code: data.code }));

    if (res.meta?.requestStatus === "fulfilled") {
      setModalShow(true);
      setLoading(false)
      reset();
      await fetch()
      setModalMessage(res?.payload?.data);
      setTimeout(() => {
        setModalShow(false);
      }, 2000);
    } else {
      setLoading(false)

      setModalMessage(res?.payload?.errors || "Submission failed. Please try again");
      setModalShow(true);
      setTimeout(() => setModalShow(false), 1000);
    }
  };

  return (
    <>
      <section className="Gift">
        <Common_white_header headingText={"Gift"} />
        <div className="container">
          <div className="gift_banner_img_holder">
            <img
              src="/assets/images/gift/banner_img.png"
              alt="banner"
              className="banenr_img"
            />
          </div>

          <div className="card_holder">
            <div className="text_holder">
              <p>Hi </p>
              <p>We have a gift for you</p>

              <h6>Please enter the gift code below</h6>

              <div className="field_holder">
                <Form.Group className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Please enter gift code"
                    isInvalid={errors.code}
                    {...register("code", {
                      required: "Please Enter a Gift code",
                      minLength: {
                        value: 4,
                        message: "Code must be at least 4 characters",
                      },
                    })}
                  />
                  {errors.code && (
                    <small className="text-danger">
                      {errors.code.message}
                    </small>
                  )}
                </Form.Group>
              </div>

              <Button
                className="btn_register_bg mb-3"
                onClick={handleSubmit(onSubmit)}
                disabled={loading}
              >
                {loading ? "Processing..." : "Receive"}
              </Button>
            </div>
          </div>

          <div className="Gift_History_holder">
            <div className=" History_header">
              <div className="header-left">
                <span className="header_icon">
                  <FontAwesomeIcon icon={faBook} />
                </span>
                <h4> History</h4>
              </div>
            </div>
            {giftHistory?.data?.map((item) => (
              <div key={item.id} className="history_card gift_history">
                <div className="history_info">
                  <h4>GIFT CODE : {item.Gift_Code?.code}</h4>
                  <p className="history_sub">GIFT NAME : {item.Gift_Code?.name}</p>
                  <span className="history_time">
                    {formatNotifDate(item.createdAt)}
                  </span>
                </div>

                <div className="history_value">
                  {item.discount_price && <div>{formatAmount(item.discount_price)}</div>}
                </div>
              </div>
            ))}
          </div>
        </div>
        {giftHistory?.total_pages > 1 && (
          <CustomPagination
            currentPage={giftHistory?.current_page}
            totalPages={giftHistory?.total_pages}
            handlePageChange={handlePageChange}
          />
        )}
      </section>
      <Successfull_strip_modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        textMsg={modalMessage}
      />
    </>
  );
}

export default Gift;
